import {
  Box,
  Button,
  CircularProgress,
  //Fab,
  Grid,
  //IconButton,
  //Menu,
  //MenuItem,
  Typography,
} from "@mui/material";
//import MoreVertIcon from "@mui/icons-material/MoreVert";
//import EditIcon from "@mui/icons-material/Edit";
//import DeleteIcon from "@mui/icons-material/Delete";
import React, { useState, useEffect } from "react";
//import AddIcon from "@mui/icons-material/Add";
import moment from "moment";
//import { useStyles } from "../../style";
import EditEvent from "./edit_event";
import DeletePopup from "../shared/delete_popup";
import AccessLocalStorage from "../../services/localStorage";
import {getApiUrl} from "../../services/api_service";
import ViewEvent from "./view_event";
import { button, carejourneytabcontainer, carejourneytabheading, eventDateTime, eventDetails, eventTitle, pcolor, pointer } from "../../style2";

export default function Interventions() {
  //const classes = useStyles();
  const rowsPerPageValue = 4;
  const [interventions, setInterventions] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(rowsPerPageValue);
  const [viewMore, setViewMore] = useState(false);

  const [anchorEls, setAnchorEls] = useState([]);
  const [anchorPosition, setAnchorPosition] = useState(null);

  const ls = new AccessLocalStorage();
  const [openEditIntervention, setOpenEditIntervention] = useState(false);
  const [openViewIntervention, setOpenViewIntervention] = useState(false);
  const [openAddIntervention, setOpenAddIntervention] = useState(false);
  const [openDeletePopup, setOpenDeletePopup] = useState(false);

  const [selectedIntervention, setSelectedIntervention] = useState([]);

  const handleViewMore = () => {
    viewMore ? setViewMore(false) : setViewMore(true);
    viewMore
      ? setRowsPerPage(rowsPerPageValue)
      : setRowsPerPage(interventions.length);
  };

  const handleMenuClick = (event, index) => {
    const newAnchorEls = [...anchorEls];
    newAnchorEls[index] = event.currentTarget;
    setAnchorEls(newAnchorEls);
    const { left, top } = event.currentTarget.getBoundingClientRect();
    setAnchorPosition({ left, top });
  };
  const handleMenuClose = (index) => {
    const newAnchorEls = [...anchorEls];
    newAnchorEls[index] = null;
    setAnchorEls(newAnchorEls);
    setAnchorPosition(null);
  };
  const handleClickOpenEditIntervention = (selectedIntervention, index) => {
    setSelectedIntervention(selectedIntervention);
    setOpenEditIntervention(true);
    //console.log("event edit id:", selectedIntervention.id);
    handleMenuClose(index); // to close the menu after opening the edit popup
  };
  const handleClickOpenViewIntervention = (selectedIntervention) => {
    setSelectedIntervention(selectedIntervention);
    setOpenViewIntervention(true);
    //console.log("event view id:", selectedIntervention.id);
  };
  const handleClickAddIntervention = () => {
    setOpenAddIntervention(true);
  };
  const handleClickCloseIntervention = () => {
    setOpenEditIntervention(false);
    setOpenViewIntervention(false);
    setOpenAddIntervention(false);
    setSelectedIntervention(""); // reset the selected event so the edit dialog will contain new data
  };

  const handleClickDeleteIntervention = (id, index) => {
    handleMenuClose(index);
    setOpenDeletePopup(true);
    setInterventions(
      interventions.filter((intervention) => intervention.id !== id)
    );
    viewMore
      ? setRowsPerPage(rowsPerPageValue)
      : setRowsPerPage(interventions.length);
  };

  const handleClickCloseDeletePopup = () => {
    setOpenDeletePopup(false);
  };
  // const getRandomColor = () => {
  //   const letters = '0123456789ABCDEF';
  //   let color = '#';
  //   for (let i = 0; i < 6; i++) {
  //     color += letters[Math.floor(Math.random() * 16)];
  //   }
  //   return color;
  // };
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const authTokens = localStorage.getItem("authTokens");
    let token;

    if (authTokens) {
      const parsedAuthTokens = JSON.parse(authTokens);
      token = parsedAuthTokens?.accessToken;
    }
    if (!token) {
      setError("Unauthorized. No token available.");
      setLoading(false);
      return;
    }

    fetch(
      `${getApiUrl()}${process.env.REACT_APP_GET_INTERVENTIONS
      }/${ls.getCurrentPatientId()}/${"416BAF04-ED87-4AB1-90E9-DE13DE602827"}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        //console.log(data);
        setInterventions(data);
      })
      .catch((err) => {
        setError(err.message || "An error occurred.");
        setInterventions([]);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <Box sx={{ position: "relative", padding: "0px" }}>
      <Grid container>
        <Grid item xs={11} >
          <Typography sx={carejourneytabheading}>Interventions</Typography>
        </Grid>
        {loading ? <Grid item xs={1}><CircularProgress /></Grid> : null}
      </Grid>
      <Box sx={carejourneytabcontainer}>
        {interventions != null && interventions.length > 0 ? interventions.slice(0, rowsPerPage).map((intervention, index) => {
          return (
            <Grid container direction="row" alignItems="flex-start" key={intervention.id}>
              <Grid item xs={3}  sx={{...eventDateTime, backgroundColor: "#FAE6EC" }}>
                <div onClick={() => handleClickOpenViewIntervention(intervention)} style={{ cursor: "pointer", textAlign: "center" }}>
                  <Typography sx={{...eventTitle, color: pcolor }}>
                    {moment(intervention.startDate).format("DD.MM.YYYY")}
                  </Typography>
                  <Typography sx={{ fontSize: "14px", color: pcolor }}>
                    {moment(intervention.startDate).format("h:mm A")}
                  </Typography>
                </div>
              </Grid>
              <Grid container item xs={9}  alignItems="flex-start" justifyContent="space-between"
                sx={{...eventDetails, backgroundColor: "#FAE6EC" }}>
                <Grid item xs={7} sm={9} md={10}>
                  <div onClick={() => handleClickOpenViewIntervention(intervention)} style={pointer}>
                    <Typography sx={{...eventTitle, color: pcolor }}>
                      {intervention.title != null
                        ? intervention.title.length > 50 ? intervention.title.substring(0, 50) + "..." : intervention.title : null}</Typography>
                    <Typography sx={{ color: "#535353", fontSize: "14px" }}>
                      {intervention.description ? intervention.description.length <= 50
                        ? intervention.description
                        : intervention.description.substring(0, 50) + "..." : null}
                    </Typography>
                  </div>
                </Grid>
                {/* <Grid item>
                    <IconButton
                      id={`basic-button-${index}`}
                      aria-controls={`basic-menu-${index}`}
                      onClick={(event) => handleMenuClick(event, index)}
                    >
                      <MoreVertIcon />
                    </IconButton>
                    <Menu
                      id={`basic-menu-${index}`}
                      anchorEl={anchorEls}
                      MenuListProps={{
                        "aria-labelledby": `basic-button-${index}`,
                      }}
                      open={Boolean(anchorEls[index])}
                      onClose={() => handleMenuClose(index)}
                      anchorPosition={anchorPosition}
                      anchorReference="anchorPosition"
                    >
                      <MenuItem
                        onClick={() =>
                          handleClickOpenEditIntervention(intervention, index)
                        }
                        disableRipple
                      >
                        <EditIcon />
                        <Box m={1} />
                        Edit
                      </MenuItem>
                      <MenuItem
                        onClick={() =>
                          handleClickDeleteIntervention(intervention.id, index)
                        }
                        disableRipple
                      >
                        <DeleteIcon />
                        <Box m={1} />
                        Delete
                      </MenuItem>
                    </Menu>
                  </Grid> */}
              </Grid>
            </Grid>
          );
        }) : loading ? null : <Box>No Interventions</Box>}
      </Box>
      <Box m={3} />
      <Grid Container style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
        <Grid item>
          {!viewMore && interventions.length > rowsPerPageValue ? (
            <Button sx={button} onClick={handleViewMore}>
              Show More
            </Button>
          ) : (
            <Box m={4} />
          )}
        </Grid>
      </Grid>
      <EditEvent
        open={openEditIntervention}
        handleClose={handleClickCloseIntervention}
        eventType={"Intervention"}
        eventData={selectedIntervention}
      />
      <ViewEvent open={openViewIntervention} handleClose={handleClickCloseIntervention} eventType={"Intervention"} eventData={selectedIntervention} />
      <EditEvent
        open={openAddIntervention}
        handleClose={handleClickCloseIntervention}
        eventType={"Intervention"}
        eventData={selectedIntervention}
      />
      <DeletePopup
        open={openDeletePopup}
        handleClose={handleClickCloseDeletePopup}
      />
    </Box>
  );
}
